import {ComponentData} from "../../engine/tools/EntityManager";
import {Vector2} from "../../engine/utils/Vector2";

export class Gravity implements ComponentData {
    value: Vector2

    constructor(x = 0, y = 0) {
        this.value = new Vector2(x, y)
    }
}